export default "__VITE_PUBLIC_ASSET__1b5b99ae__"